import {makeRequest} from "../../helpers/network_utils";
import {GET_REQUEST} from "../../values/globals";
import endpoints from "../../routes/endpoints";
import {parseErrorResponse, showAlert} from "../../helpers/helper_functions";

export const FETCH_INCOME_TYPES = "fetch_income_types";
export const LOADING_INCOME_TYPES = "loading_income_types";

export const getIncomeTypes = () => {
    return dispatch => {
        dispatch({
            type: LOADING_INCOME_TYPES
        })
        makeRequest(GET_REQUEST, `${endpoints.income_types}`, {}, response => {
            const payload = response.data;
            return dispatch({
                payload: payload,
                type: FETCH_INCOME_TYPES
            })
        }, error => {
            showAlert('error', "Error!", parseErrorResponse(error));
            return dispatch({
                payload: [],
                type: FETCH_INCOME_TYPES
            })
        }).then();
    }
}